import Swal from 'sweetalert2';
import { validationForm } from '../../_utilFreeform';

const formulario = document.getElementById('formiWithMap');

if (formulario) {
  formulario.addEventListener('freeform-on-submit', function (event) {
    const form = event.form;
    let notas_formulario = '';
    const tituloPipedrive = form.querySelector('[name="tituloPipedriveLead"]');
    const empresa = form.querySelector('[name="company"]');
    const mensaje = form.querySelector('[name="message"]');
    const notes = form.querySelector('[name="notas"]');
    const checkboxes_asuntos = form.querySelectorAll('input[name="asunto[]"]:checked');
    if(checkboxes_asuntos.length > 0){
      const asuntos = Array.from(checkboxes_asuntos).map(checkbox => checkbox.value);
      const Asuntos_concatenados = asuntos.join(', '); // Separa por comas
      if(asuntos.length>0){
        notas_formulario = notas_formulario + ' Asunto: '+ Asuntos_concatenados+' \n';
      }
    }
    if(mensaje){
      notas_formulario = notas_formulario + ' Mensaje: '+ mensaje.value+' \n';
    }
    if(tituloPipedrive){
      if(!tituloPipedrive.value.includes(empresa.value)){
        tituloPipedrive.value = `[${tituloPipedrive.value}] [${empresa.value ?? ''}]`;
      }
    }
    if(notes){
      notes.value=notas_formulario;
    }
  });
  formulario.addEventListener('freeform-ajax-success', function (event) {
    const { success } = event.response;
    if (success) {
      try {
        gtag('event', 'contacto_enviado', {
          event_category: 'Form submit',
          event_label: 'Form enviado'
        });
      } catch (error) {
        console.log(error);
      }
    }
  });

  /*formulario.addEventListener('submit', (event) => {*/
  /*event.preventDefault();*/
  /*var fields = ['fullName', 'city', 'company', 'email', 'phone'];*/
  /*var form = event.target;*/
  /*var data = new FormData(form);*/
  /*var method = form.getAttribute('method');*/
  /*var action = form.getAttribute('action');*/
  /*var request = new XMLHttpRequest();*/
  /*request.open(method, action ? action : window.location.href, true);*/
  /*request.setRequestHeader('Cache-Control', 'no-cache');*/
  /*// Set the Craft specific AJAX headers*/
  /*request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');*/
  /*request.setRequestHeader('HTTP_X_REQUESTED_WITH', 'XMLHttpRequest');*/
  /*request.onload = function () {*/
  /*console.log(request.status);*/
  /*if (request.status === 200) {*/
  /*var response = JSON.parse(request.response);*/
  /*Swal.fire('Formulario enviado!', 'El formulario fue enviado con éxito, pronto nos pondremos en contacto contigo.', 'success');*/
  /*if (response.success && response.finished) {*/
  /*form.reset();*/
  /*try {*/
  /*gtag('event', 'contacto_enviado', {*/
  /*event_category: 'Form submit',*/
  /*event_label: 'Form enviado'*/
  /*});*/
  /*} catch (error) {*/
  /*console.log(error);*/
  /*Swal.fire({*/
  /*icon: 'error',*/
  /*title: 'Oops...',*/
  /*text: 'Parece que hubo un error al enviar el formulario, inténtalo de nuevo.'*/
  /*});*/
  /*}*/
  /*for (let i = 0; i < fields.length; i++) {*/
  /*if (document.getElementById('required-' + fields[i])) document.getElementById('required-' + fields[i]).remove();*/
  /*}*/
  /*} else if (response.errors || response.formErrors) {*/
  /*console.log('Field Errors', response.errors);*/
  /*Swal.fire({*/
  /*icon: 'error',*/
  /*title: 'Oops...',*/
  /*text: 'Parece que hubo un error al enviar el formulario, revisa los campos e inténtalo de nuevo.'*/
  /*});*/
  /*for (let i = 0; i < fields.length; i++) {*/
  /*var field = document.getElementById(fields[i]);*/
  /*if (field.value === '' && !field.parentNode.classList.contains('displayingRequired')) {*/
  /*var required = document.createElement('div');*/
  /*required.innerHTML = 'Este campo es obligatorio';*/
  /*required.className = 'required';*/
  /*required.id = 'required-' + fields[i];*/
  /*field.parentNode.appendChild(required);*/
  /*field.parentNode.classList.add('displayingRequired');*/
  /*} else if (field.value !== '' && field.parentNode.classList.contains('displayingRequired')) {*/
  /*field.parentNode.classList.remove('displayingRequired');*/
  /*document.getElementById('required-' + fields[i]).remove();*/
  /*}*/
  /*}*/
  /*}*/
  /*} else {*/
  /*console.error(request);*/
  /*}*/
  /*};*/
  /*request.send(data);*/
  /*event.preventDefault();*/
  /*});*/
}

